import React, { useState, useEffect } from "react";
import "./style.scss";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { blue, red } from "@ant-design/colors";
import { Layout, Space, Button, Table, Popconfirm, PageHeader } from "antd";
import R2Footer from "../../../components/Footer";
import TestimonialService from "../../../services/TestimonialService";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddTestimonial from "./AddTestimonial";

const { Content } = Layout;

const Testimonials = (props) => {
  const [addModal, setAddModal] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [updatedTestimonial, setUpdatedTestimonial] = useState();
  const [testimonials, setTestimonials] = useState([]);

  const columns = [
    {
      title: "Action",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
            }}
          >
            {testimonials?.length > 0 && (
              <>
                <EditOutlined
                  style={{ color: blue[5] }}
                  onClick={() => {
                    setUpdatedTestimonial(record);
                    setEdit(true);
                    setAddModal(true);
                  }}
                />
                &nbsp;&nbsp;
                <Popconfirm
                  title="Sure to delete?"
                  onConfirm={() => deleteTestimonial(record.id)}
                >
                  <DeleteOutlined style={{ color: red[5] }} />
                </Popconfirm>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Date",
      dataIndex: "testimonial_date",
      key: "testimonial_date",
    },
  ];

  const deleteTestimonial = async (id) => {
    await TestimonialService.deleteTestimonial(id);
    getTestimonials();
  };

  useEffect(() => {
    getTestimonials();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAddorUpdate = () => {
    setAddModal(false);
    getTestimonials();
  };

  const getTestimonials = async () => {
    const restaurant_id = props.adminRestaurant;
    const data = await TestimonialService.getTestimonials(restaurant_id);
    setTestimonials(data?.testimonials || []);
  };

  return (
    <Layout className="u-page-layout">
      <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
          className="page-header-business"
            title="Testimonials"
            extra={[
              <Button
                type="primary"
                className="custom-btn"
                onClick={() => {
                  setEdit(false);
                  setAddModal(true);
                }}
              >
                Add Testimonial
              </Button>,
            ]}
          />
          <div className="text-left content-container-business">
            <Table columns={columns} dataSource={testimonials} className="overflow-auto"/>
          </div>
        </Space>
      </Content>
      {addModal && (
        <AddTestimonial
          modalOpen={true}
          isEdit={isEdit}
          closeModal={() => setAddModal(false)}
          updatedTestimonial={updatedTestimonial}
          onAddorUpdate={onAddorUpdate}
        />
      )}
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(Testimonials));
